import React,{useState, useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';

import { useSelector, useDispatch } from "react-redux";
import { selectRooms,getAllStaffByRoom,getTimeTmpltByRoom,getTimeZoneByRoom } from '../../../../redux/selectors/scheduleAttendantSelectros';
import { saveScheduleRecord } from '../../../../redux/reducers/scheduleAttendantReducer';

import { makeStyles } from '@material-ui/styles';

import { FormControl,InputLabel, MenuItem ,Select, Button, IconButton, Dialog, DialogTitle,DialogContent,DialogActions,TextField, Menu} from '@material-ui/core';
import {ExpandMore as ExpandMoreIcon, Delete as DeleteIcon} from '@material-ui/icons';
import Alert from '@material-ui/lab/Alert';

import validate from 'validate.js';
import moment from 'moment';
import 'moment/locale/ru';

validate.extend(validate.validators.datetime, {
    parse: function(value, options) {
      return +moment.utc(value);
    },
    format: function(value, options) {
      var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm:ss";
      return moment.utc(value).format(format);
    }
  });

//проверим что время окончания не больше времени начала
validate.validators.custom = function(value, options, key, attributes) {
    if (moment(value,"HH:mm").isBefore(moment(attributes[options.compareKey],"HH:mm"))) {
        return "^Ошибка";
    }
};

validate.validators.custom5 = function(value, options, key, attributes) {
    if (moment(value,"HH:mm").isBefore(moment(options.time,"HH:mm"))) {
        return "^Ошибка <"+options.time;
    }
};

const useStyles = makeStyles(theme => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '260px'

    },
    timeSelect: {
        display: 'flex',
        justifyContent: 'space-between',
       
    },
    size: {
        fontSize:'16px'
    },
    alert: {
        width:'280px',
        margin: '5px auto 10px'
    }
}));

const AddDialog = props => {
    const {open, init, onClose } = props;
  
    const classes = useStyles();
    const dispatch = useDispatch();

    const rooms = useSelector(selectRooms);
    const { schAtt, addDialogAlert } = useSelector(state => state.schAttenReducer); 

    const [formState, setFormState] = useState({
        isValid: false,
        isTouched: false,
        values: { ...init },
        touched: {},
        errors: {}
    });

    const [anchorTimeTmpltMenu, setAnchorTimeTmpltMenu] = useState(null);

    const timezone = useSelector(getTimeZoneByRoom(formState.values.room));

    const staff = useSelector(getAllStaffByRoom(formState.values.room))||[];

    const timeTmplt = useSelector(getTimeTmpltByRoom(formState.values.room));
   
    const limitCalendar = useMemo(() => {

        //ограничения выбора для календаря
        const today = moment.utc().format("YYYY-MM-DD");
        //const today = moment.unix(schAtt[0].s).format("YYYY-MM-DD");
        if (schAtt&&schAtt.length>0) {
            return {
                min:today,
                max:moment.unix(schAtt[schAtt.length-1].s).utc().format("YYYY-MM-DD")
            }
        }
        return {min:today,max:today}
    },[schAtt]);
    

    useEffect(() => {

        const schema = {
            dateShift: {
                presence: { allowEmpty: false, message: '^Введите дату' },
                datetime: {
                    dateOnly: true,
                    earliest: moment.utc(limitCalendar.min),
                    latest: moment.utc(limitCalendar.max),
                    message: "^Недопустимая дата дежурства"
                }
            },
            room: {
                presence: true,
                length: { minimum: 3 }
            },
            staff: {
                presence: true,
                length: { minimum: 3 }
            },
            timeStart: {
                presence: { allowEmpty: false, message: '^Введите время' },
                custom5: { time: "05:00" }

            },
            timeEnd: {
                presence: { allowEmpty: false, message: '^Введите время' },
                custom: { compareKey: "timeStart" }
            }

        };

        const errors = validate(formState.values, schema);

        setFormState(formState => ({
            ...formState,
            isValid: errors ? false : true,
            errors: errors || {}
        }));
    }, [formState.values, limitCalendar]);
    
    const handleChange = event => {
        event.persist();
        setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]:
                    event.target.type === 'checkbox'
                        ? event.target.checked
                        : event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true
            },
            isTouched: true
        }));
    };

    const handleChangeRoom = event => {
        event.persist();
        setFormState({...formState,
            values: {
                ...formState.values,
                room: event.target.value,
                staff: "0"
            },
            touched: {
                ...formState.touched,
                room: true,
                staff: true
              },
            isTouched: true
        });
    };  

    const handleClickTmpltMenu = (event) => {
        setAnchorTimeTmpltMenu(event.currentTarget);
    };
    
    const handleCloseTmpltMenu = () => {
        setAnchorTimeTmpltMenu(null);
    };

    const clickTmplt = (tmplt) =>{
        setFormState({...formState,
            values: {...formState.values,
                timeStart:moment.unix(tmplt.timeStart).utcOffset(timezone).format("HH:mm"),
                timeEnd:moment.unix(tmplt.timeEnd).utcOffset(timezone).format("HH:mm")
            },
            touched: {
                ...formState.touched,
                timeStart: true,
                timeEnd: true
            },
            isTouched: true

        });
        setAnchorTimeTmpltMenu(null);
    };

    const handleSaveData = (del=false) => {

        let data ={};
        let oldData = {};

        if (!del) {
            const shift = moment(formState.values.dateShift).format("YYYY-MM-DD");
            data = {
                room: formState.values.room,
                staff: formState.values.staff,
                timeStart: moment(shift+" "+formState.values.timeStart).utcOffset(timezone,true).toJSON(),
                timeEnd: moment(shift+" "+formState.values.timeEnd).utcOffset(timezone,true).toJSON(),
                replace: formState.values.isReplace
            };
        }

        //это изменение данных
        if (init.isEdit) {
            const oldShift = moment(init.dateShift).format("YYYY-MM-DD");
            oldData = {
                room: init.room,
                staff: init.staff,
                timeStart: moment(oldShift+" "+init.timeStart).utcOffset(timezone,true).toJSON(),
                timeEnd: moment(oldShift+" "+init.timeEnd).utcOffset(timezone,true).toJSON(),
                replace: init.isReplace
            };
        }

        //console.log(oldData);
        //console.log(data);
        
        dispatch(saveScheduleRecord(data, oldData));
    }

    //const hasError = field => formState.touched[field] && formState.errors[field] ? true : false;
    const hasError = field => formState.errors[field] ? true : false;

    return (
        <>
            <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title" disableBackdropClick={true}>
                <DialogTitle id="form-dialog-title">{formState.values.isReplace ? "Замена в графике " : "Запись в график "}дежурств</DialogTitle>
                <DialogContent className={classes.content}>

                    <TextField
                        margin="normal"
                        variant="outlined"
                        id="date"
                        label="Дата"
                        type="date"
                        className={classes.textField}
                        InputLabelProps={{ shrink: true, }}
                        inputProps={limitCalendar}
                        name="dateShift"
                        error={hasError('dateShift')}
                        value={formState.values.dateShift || ''}
                        helperText={hasError('dateShift') ? formState.errors.dateShift[0] : null}
                        onChange={handleChange}
                        disabled
                    />

                    <FormControl variant="outlined" margin="normal">
                        <InputLabel shrink htmlFor="selectId">Помещение</InputLabel>
                        <Select
                            native
                            label="Помещение"
                            inputProps={{ label: 'Помещение', id: 'selectId', }}
                            name="room"
                            error={hasError('room')}
                            value={formState.values.room || ''}
                            //helperText={ hasError('room') ? formState.errors.room[0] : null }
                            onChange={handleChangeRoom}
                            disabled
                        >
                            <option value="0" hidden>...</option>
                            {rooms.map(room => (
                                <option key={room.guid} value={room.guid} >{room.name}</option>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl variant="outlined" margin="normal">
                        <InputLabel shrink htmlFor="selectS">Сотрудник</InputLabel>
                        <Select
                            native
                            label="Сотрудник"
                            inputProps={{ label: 'Сотрудник', id: 'selectS' }}
                            name="staff"
                            error={hasError('staff')}
                            value={formState.values.staff || ''}
                            //helperText={ hasError('staff') ? formState.errors.staff[0] : null }
                            onChange={handleChange}
                        >
                            <option value="0" hidden>...</option>
                            {staff.map(value => (
                                <option key={value.guid} value={value.guid} >{value.name}</option>
                            ))}
                        </Select>
                    </FormControl>

                    <div className={classes.timeSelect}>
                        <TextField
                            margin="normal"
                            variant="outlined"
                            id="time"
                            label="Начало"
                            type="time"
                            className={classes.textField}
                            InputLabelProps={{ shrink: true, }}
                            inputProps={{ step: 300, }}
                            name="timeStart"
                            error={hasError('timeStart')}
                            value={formState.values.timeStart || ''}
                            helperText={hasError('timeStart') ? formState.errors.timeStart[0] : null}
                            onChange={handleChange}
                        />

                        <TextField
                            margin="normal"
                            variant="outlined"
                            id="time"
                            label="Окончание"
                            type="time"
                            className={classes.textField}
                            InputLabelProps={{ shrink: true, }}
                            inputProps={{ step: 300, }}
                            name="timeEnd"
                            error={hasError('timeEnd')}
                            value={formState.values.timeEnd || ''}
                            helperText={hasError('timeEnd') ? formState.errors.timeEnd[0] : null}
                            onChange={handleChange}
                        />
                        <IconButton onClick={handleClickTmpltMenu} edge="end">
                            <ExpandMoreIcon />
                        </IconButton>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleSaveData(true)} color="secondary" disabled={!init.isEdit || formState.isTouched}>
                        Удалить
                    </Button>
                    <Button onClick={onClose} color="primary">
                        Отмена
                    </Button>
                    <Button onClick={() => handleSaveData()} color="primary" disabled={!formState.isValid || !formState.isTouched}>
                        Сохранить
                    </Button>
                </DialogActions>
                {!Boolean(addDialogAlert) ? null :
                    <div className={classes.alert}>
                        <Alert severity="error">{addDialogAlert}</Alert>
                    </div>
                }
            </Dialog>
            <Menu
                id="simple-menu"
                anchorEl={anchorTimeTmpltMenu}
                keepMounted
                open={Boolean(anchorTimeTmpltMenu) && timeTmplt.length > 0}
                onClose={handleCloseTmpltMenu}
            >
                {timeTmplt.map(tmplt => (
                    <MenuItem key={tmplt.timeStart + tmplt.timeEnd} onClick={() => clickTmplt(tmplt)}>
                        {moment.unix(tmplt.timeStart).utcOffset(timezone).format("HH:mm")}
                    -
                        {moment.unix(tmplt.timeEnd).utcOffset(timezone).format("HH:mm")}
                    </MenuItem>
                ))}
            </Menu>
        </>    
    );
};

AddDialog.propTypes = {
    open: PropTypes.bool, 
    onClose: PropTypes.func,
    init: PropTypes.object
    
};

export default AddDialog;
